export const REDUCER_KEY = 'committedBaskets';
